module.exports = __webpack_public_path__ + "static/media/IKMS08.793c08ea.jpg";